var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 160,
    height: 160,
    rx: 8,
    fill: "#263238"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 80,
    height: 4,
    rx: 2,
    fill: "#4CAF50"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 120,
    height: 4,
    rx: 2,
    fill: "#FF5722"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 100,
    height: 4,
    rx: 2,
    fill: "#FFC107"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 110,
    width: 90,
    height: 4,
    rx: 2,
    fill: "#FFC107"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 130,
    width: 60,
    height: 4,
    rx: 2,
    fill: "#4CAF50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40 L50 40 L50 150 L40 150",
    stroke: "#90A4AE",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 40 L150 40 L150 150 L160 150",
    stroke: "#90A4AE",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/web-development.e9cb020818387f7a7dde753b21c896ce.svg";
export { ForwardRef as ReactComponent };